<template>
  <div class="card cads">
    <div class="card-header">CADS Details</div>
    <div class="card-body">
      <table class="table table-borderless">
        <thead class="thead-light">
          <tr>
            <th>AC ID</th>
            <th>Serial Number</th>
            <th>SAP Order Number</th>
            <th>LIC Item Number</th>
            <th>SKU</th>
            <th>Delivery Date</th>
            <th>Term End Date</th>
            <th>MP End Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in data" :key="item.ID">
            <td>{{ item.AssetComponentID }}</td>
            <td>{{ item.SerialNumber }}</td>
            <td>{{ item.SalesOrderNumber }}</td>
            <td>{{ item.LicensingItemNumber }}</td>
            <td>{{ item.SKU }}</td>
            <td>{{ getReadableDate(item.DeliveryDate) }}</td>
            <td>{{
              item.TermExpDate === null
                ? 'Permanent'
                : getReadableDate(item.TermExpDate)
            }}</td>
            <td>{{ getReadableDate(item.MPEndDate) }}</td>
            <td>{{ item.Status }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'LicenseCheckerCadsDetails',
  props: {
    data: { type: Array, default: () => ([]) }
  },
  methods: {
    getReadableDate (date) {
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>

<style>
.cads.card {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/license-checker/license-checker-cads-details.vue